import React, { useState, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Button,
  Th,
  Td,
  Skeleton,
  Box,
  useToast,
} from "@chakra-ui/react";
import CategoryItem from "./CategoryItem";
import useFetch from "../../../hooks/useFetch";
import ConfirmationSwal from "../../../Utils/confirmationSwal";

function CategoriesTable() {
  const [categories, setCategories] = useState([]);
  const [showNewCategory, setShowNewCategory] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { get, del, post, put } = useFetch();
  const toast = useToast();

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    setIsLoading(true);
    await get("/products/properties/categories")
      .then((res) => {
        setCategories(res);
        setIsLoading(false);
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const updateCategory = async (category) => {
    await put(`/products/properties/categories/${category.id}`, category)
      .then(() => {
        getCategories();
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const addCategory = async (category) => {
    await post(`/products/properties/categories`, category)
      .then(() => {
        getCategories();
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const removeCategories = async (category) => {
    ConfirmationSwal.fire({
      title: "Eliminar categoría",
      text: "¿Desea eliminar la categoría?",
      icon: "question",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await del(`/users/categories/${category.id}`)
          .then(() => {
            getCategories();
          })
          .catch((e) => {
            toast({
              title: "Se ha producido un error.",
              description:
                e?.message || "Contacte con el administrador del sistema.",
              status: "error",
              duration: 4000,
              isClosable: true,
            });
          });
      }
    });
  };

  return (
    <>
      <Button
        my="2"
        colorScheme="blue"
        onClick={() => setShowNewCategory(true)}
        isDisabled={showNewCategory}
      >
        + Categoria
      </Button>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
          <Thead>
            <Tr>
              <Th fontSize="0.8em">Nombre</Th>
              <Th fontSize="0.8em">Orden</Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoading ? (
              <Tr>
                <Td colSpan="100%">
                  <Skeleton h="1rem" />
                </Td>
              </Tr>
            ) : (
              <>
                {showNewCategory && (
                  <CategoryItem
                    category={{}}
                    setShowNewCategory={setShowNewCategory}
                    addCategory={addCategory}
                    initialAction={"new"}
                  />
                )}
                {categories.map((category) => (
                  <CategoryItem
                    key={category.id}
                    category={category}
                    setShowNewCategory={setShowNewCategory}
                    updateCategory={updateCategory}
                    deleteCategories={removeCategories}
                  />
                ))}
              </>
            )}
          </Tbody>
        </Table>
      </Box>
    </>
  );
}

export default CategoriesTable;
